import {gql} from "@irati/utils/gql"

const bulkChangeEmailMutation = gql`
  mutation BulkChangeEmail($businessId: ID!, $changes: [EmailChange]) {
    bulkChangeEmail(businessId: $businessId, changes: $changes)
  }
`

export default bulkChangeEmailMutation
